import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  image:
    ".image-with-text__image .image, .image-with-text__image .placeholder-svg",
  animateBackground: ".animation--section-introduction-background",
  sectionBlockItems: ".animation--section-introduction > *",
};

export default node => {
  if (!shouldAnimate(node)) return;

  // Add the animation delay offset variables
  delayOffset(node, [
    selectors.image,
    selectors.animateBackground,
    selectors.sectionBlockItems,
  ]);

  const observer = intersectionWatcher(node);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
